module.exports = "<h3>Liste des requérants</h3>\n<div *ngFor=\"let requerant of requerants; let first = first\" class=\"added-requerant\">\n    <jhi-fiche-acteur added-list\n        [acteur]=\"requerant\"\n        [isPrincipal]=\"first && !requerant.isAnonymous\"\n        (onClick)=\"removeRequerant(requerant)\"\n        (onMoveToPrincipal)=\"moveToRequerantPricipal(requerant)\">\n    </jhi-fiche-acteur>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/added-requerant/added-requerant.component.html
// module id = 787
// module chunks = 0